import { render, staticRenderFns } from "./IncreaseIndicator.vue?vue&type=template&id=04f97a58&scoped=true&"
import script from "./IncreaseIndicator.vue?vue&type=script&lang=js&"
export * from "./IncreaseIndicator.vue?vue&type=script&lang=js&"
import style0 from "./IncreaseIndicator.vue?vue&type=style&index=0&id=04f97a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f97a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
